// extracted by mini-css-extract-plugin
export default {"section":"uSRipBuPSBZQkiUzydDA","wrapper":"nqhGwrgurMcoV0LoNfnZ","texts":"X_blX3um8tjH8IpH7jup","title":"xzWHYZQWfZzZplOK2B4X","description":"byVVfFIiXnKahuzSBDjg"};